import React from 'react'

const Accordion = () => {
	return (
		// {/* // x---------------------------------x Accordion Section x---------------------------------x */}
		<div className="row">
			<div className="col-md-12">
				<div className='card h-100'>
					<div className="rounded-4 mb-3 mb-sm-0 bg-white">
						<div className="card-body">
							<div className="px-xl-5 px-lg-4 px-3 py-3 page-body bg-card">
								<h4 className="mb-4">Accordion</h4>
								<p className="lead">The accordion uses collapse internally to make it collapsible. To render an accordion that’s expanded, add the .open class on the <code>.accordion</code>.</p>
								<div className="row g-4">
									<div className="col-12">
										<div className="accordion" id="accordionExample">
											<div className="accordion-item">
												<h3 className="accordion-header" id="headingOne">
													<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
														Accordion Item #1
													</button>
												</h3>
												<div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
													<div className="accordion-body">
														<strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h3 className="accordion-header" id="headingTwo">
													<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
														Accordion Item #2
													</button>
												</h3>
												<div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
													<div className="accordion-body">
														<strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h3 className="accordion-header" id="headingThree">
													<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
														Accordion Item #3
													</button>
												</h3>
												<div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
													<div className="accordion-body">
														<strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-12">
										<h5>Flush</h5>
										<p>Add <code>.accordion-flush</code> to remove the default <code>background-color</code>, some borders, and some rounded corners to render accordion edge-to-edge with their parent container.</p>
										<div className="accordion accordion-flush" id="accordionFlushExample">
											<div className="accordion-item">
												<h3 className="accordion-header" id="flush-headingOne">
													<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
														Accordion Item #1
													</button>
												</h3>
												<div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
													<div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item's accordion body.</div>
												</div>
											</div>
											<div className="accordion-item">
												<h3 className="accordion-header" id="flush-headingTwo">
													<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
														Accordion Item #2
													</button>
												</h3>
												<div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
													<div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the second item's accordion body. Let's imagine this being filled with some actual content.</div>
												</div>
											</div>
											<div className="accordion-item">
												<h3 className="accordion-header" id="flush-headingThree">
													<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
														Accordion Item #3
													</button>
												</h3>
												<div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
													<div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the third item's accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application.</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-12">
										<h5>Always open</h5>
										<p>Omit the <code>data-bs-parent</code> attribute on each <code>.accordion-collapse</code> to make accordion items stay open when another item is opened.</p>
										<div className="accordion" id="accordionPanelsStayOpenExample">
											<div className="accordion-item">
												<h3 className="accordion-header" id="panelsStayOpen-headingOne">
													<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
														Accordion Item #1
													</button>
												</h3>
												<div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
													<div className="accordion-body">
														<strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h3 className="accordion-header" id="panelsStayOpen-headingTwo">
													<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
														Accordion Item #2
													</button>
												</h3>
												<div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
													<div className="accordion-body">
														<strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h3 className="accordion-header" id="panelsStayOpen-headingThree">
													<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
														Accordion Item #3
													</button>
												</h3>
												<div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
													<div className="accordion-body">
														<strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Accordion